export const WIDTH_MAP_RETURN_TABLE: Record<string, number> = {
  "region": 246,
  "country": 146,
  "system": 146,
  "channel": 146,
  "language": 146,
  "bundle": 146,
  "ua_network": 160,
  // 当前最长version有2021.3.56.31013(2021.3.56.31013)	
  "version": 260,
  "campaign": 146,
};